/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssessmentsIncludeFilterItems } from './assessmentsIncludeFilterItems';
import { AssessmentsScopeFilter } from './assessmentsScopeFilter';


export interface AssessmentsIncludeFilterInner { 
    relation?: AssessmentsIncludeFilterInner.RelationEnum;
    scope?: AssessmentsScopeFilter;
}
export namespace AssessmentsIncludeFilterInner {
    export type RelationEnum = 'company' | 'sections' | 'questions' | 'configs' | 'participants' | 'responses';
    export const RelationEnum = {
        Company: 'company' as RelationEnum,
        Sections: 'sections' as RelationEnum,
        Questions: 'questions' as RelationEnum,
        Configs: 'configs' as RelationEnum,
        Participants: 'participants' as RelationEnum,
        Responses: 'responses' as RelationEnum
    };
}


